import React from 'react';
import { Users, DollarSign, TrendingUp, Star } from 'lucide-react';

const SocialProofStats = () => {
  const stats = [
    {
      icon: Users,
      value: '10,000+',
      label: 'Active Traders',
      color: '#00D9FF'
    },
    {
      icon: DollarSign,
      value: '$50M+',
      label: 'Assets Under Management',
      color: '#C9A04B'
    },
    {
      icon: TrendingUp,
      value: '500K+',
      label: 'Successful Trades',
      color: '#4ADE80'
    },
    {
      icon: Star,
      value: '4.9/5',
      label: 'Average Rating',
      color: '#00B67A'
    }
  ];

  return (
    <div className="social-proof-stats">
      <div className="stats-container">
        {stats.map((stat, index) => {
          const Icon = stat.icon;
          return (
            <div key={index} className="stat-item">
              <div className="stat-icon-wrapper" style={{ backgroundColor: `${stat.color}20` }}>
                <Icon className="stat-icon" style={{ color: stat.color }} />
              </div>
              <div className="stat-content">
                <div className="stat-value">{stat.value}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SocialProofStats;
